
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 64 64"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#62C4C3","d":"M6 6.999h12v2H6zM6 10.999h12v2H6zM6 14.999h12v2H6zM6 18.999h12v2H6zM6 22.999h12v2H6zM48 4.999h13v2H48zM48 8.999h13v2H48zM48 12.999h13v2H48zM47 16.999h13v2H47zM46 20.999h13v2H46zM43 24.999h13v2H43zM40 28.999h13v2H40zM36 32.999h13v2H36zM34 36.999h13v2H34zM32 40.999h13v2H32zM32 44.999h13v2H32zM32 48.999h13v2H32zM32 52.999h13v2H32zM32 56.999h13v2H32z"}}),_c('path',{attrs:{"fill":"#EFBC2E","d":"M58 4v9.37A23.425 23.425 0 0150 31a23.425 23.425 0 00-8 17.63V60a2 2 0 004 0v-9.37A23.425 23.425 0 0154 33a23.425 23.425 0 008-17.63V4a2 2 0 00-4 0z"}}),_c('path',{attrs:{"fill":"#62C4C3","d":"M6 38.999h12v2H6zM6 42.999h12v2H6zM6 46.999h12v2H6zM6 50.999h12v2H6zM6 54.999h12v2H6z"}}),_c('path',{attrs:{"fill":"#EF941D","d":"M18 60v-9.37A23.425 23.425 0 0010 33a23.425 23.425 0 01-8-17.63V4a2 2 0 014 0v9.37A23.425 23.425 0 0014 31a23.425 23.425 0 018 17.63V60a2 2 0 01-4 0z"}}),_c('path',{attrs:{"fill":"#EFBC2E","d":"M18 4v9.37A23.425 23.425 0 0110 31a23.425 23.425 0 00-8 17.63V60a2 2 0 004 0v-9.37A23.425 23.425 0 0114 33a23.425 23.425 0 008-17.63V4a2 2 0 00-4 0z"}})])
          )
        }
      }
    